import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于甜柚漫画，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg p-5 md:p-6"
              style={{ backgroundColor: 'oklch(var(--background-50))' }}
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" style={{ backgroundColor: 'oklch(var(--primary-100))', color: 'oklch(var(--primary-600))' }}>
                  Q
                </span>
                {item.q}
              </h3>
              <div className="pl-9">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}